import {
  Bot,
  Workflow,
  Users,
  LayoutTemplate,
  MonitorSmartphone,
  Sparkles,
  BrainCircuit,
  ServerCog,
  Cloud,
  Shield,
  ShieldCheck,
  Server,
  Code2,
  Cpu,
} from "lucide-react";

export const iconMap = {
  Bot,
  Workflow,
  Users,
  LayoutTemplate,
  MonitorSmartphone,
  Sparkles,
  BrainCircuit,
  ServerCog,
  Cloud,
  Shield,
  ShieldCheck,
  Server,
  Code2,
  Cpu,
};

export const getIcon = (name) => iconMap[name] || Cpu;
